import { useMemo } from 'react';

export const usePortalConfig = (): { mfeTag: string | undefined } => {
    return useMemo(() => {
        const config = (window as any).PortalConfig ?? {};

        return { mfeTag: config.mfeTag };
    }, []);
};
